import {DIALOG_TYPE, LayoutConfig} from "@spartacus/storefront";
import {
  GonvarriCustomerTicketingFormComponent
} from "../components/gonvarri-customer-ticketing-form/gonvarri-customer-ticketing-form.component";

export const gonvarriDefaultCreatedTicketLayoutConfig: LayoutConfig = {
    launch: {
      GONVARRI_CUSTOMER_TICKETING_CREATE: {
        inlineRoot: true,
        component: GonvarriCustomerTicketingFormComponent,
        dialogType: DIALOG_TYPE.DIALOG,
      },
    },
  };